export default

    class ClientController {

    constructor(resource) {
        this._resource = resource;
    }

    getAllClients() {

        return this._resource('clients')
            .get()
            .then(res => res.json());
    }

    getAllClientsWithVehicleModel() {
        return this._resource('clients/with-vehicle-models')
            .get()
            .then(res => res.json());
    }

    async getClientById(clientId) {
        return await this
            ._resource(`client/${clientId}`)
            .get()
            .then(res => res.body)
            .catch(e => { throw e })
    }

    getAllClientsPublic() {
        return this._resource('public/client')
            .get()
            .then(res => res.json());
    }

    async getClientsByUser() {
        let result;
        try {
            let response = await this._resource('clients/user/').get()
            result = response.json()
        } catch (error) {
            result = {
                ok: false,
                message: error
            }
        }
        return result
    }

    async getClientsByZipcode(zipcode) {
        let result;
        try {
            let code = parseInt(zipcode.replace(/\.|\-/gi, ''))
            let response = await this._resource(`clients/zipcode/${code}`).get()
            result = response.json()
        } catch (error) {
            result = {
                ok: false,
                message: error
            }
        }
        return result
    }

    async getLogoClient(){
        let result;
        try {
            let response = await this._resource('clients/logo/').get()
            result = response.body.url
        } catch (error) {
            result = {
                ok: false,
                message: error
            }
        }
        return result
    }

    async getClients() {
        let result;
        try {
            let response = await this._resource('client/').get()
            result = response.json()
        } catch (error) {
            result = {
                ok: false,
                message: error
            }
        }
        return result
    }

    async register(client,user){        
        try{
            let data = await this._resource('clients/register')
                .save({
                    name: client.name,
                    name_adm: user.name,
                    email: user.email,
                    cpf: user.cpf,
                    type_client: client.type_client
                })
            return data.json()    
              
        } catch(e) {
            throw  {
                ok: false,
                message: e.body.message
            }
        }            
    }

    async getClientsAdmin() {
        let result;
        try {
            let response = await this._resource('clients/admin').get()
            result = response.json()
        } catch (error) {
            throw {
                ok: false,
                message: error
            }
        }
        return result
    }

    async update(client) {
        let result
        try {
            let response = await this._resource(`client/${client.id}`).update(client)
            result = response.json()
        } catch (e) {
            throw {
                ok: false,
                message: error
            }
        }
        return result
    }    

    newRegister(object, file){
        let data = new FormData()
        data.append("body", JSON.stringify(object))
        data.append('temosDeUso', file)
        return this._resource('clients/new-register').save(data)
        .then(res => {
            return res
        }).catch(e => {
            throw e
        })
    }
}